import React, { useState } from 'react';
import { Modal, Card, Row, Col, Button, Space, Typography, Tag } from 'antd';
import { 
  LineChartOutlined, BarChartOutlined, PieChartOutlined, 
  DashboardOutlined, ThunderboltOutlined, TeamOutlined 
} from '@ant-design/icons';

const { Title, Text } = Typography;

const DashboardTemplates = ({ onSelectTemplate, visible, onClose }) => {
  const templates = [
    {
      id: 'performance',
      name: 'Performans Dashboard',
      description: 'Gelir, ROI ve kampanya performansı odaklı',
      icon: <LineChartOutlined style={{ fontSize: '48px', color: '#1890ff' }} />,
      widgets: [
        { key: 'revenue-forecast', settings: { size: 'large' } },
        { key: 'campaign-tracker', settings: { size: 'large' } }
      ],
      tags: ['Gelir', 'ROI', 'Kampanya']
    },
    {
      id: 'marketing',
      name: 'Pazarlama Dashboard',
      description: 'Sosyal medya ve rekabet analizi odaklı',
      icon: <BarChartOutlined style={{ fontSize: '48px', color: '#52c41a' }} />,
      widgets: [
        { key: 'social-metrics', settings: { size: 'medium' } },
        { key: 'competitor-analysis', settings: { size: 'full' } },
        { key: 'campaign-tracker', settings: { size: 'medium' } }
      ],
      tags: ['Sosyal Medya', 'Rakip Analizi', 'Pazarlama']
    },
    {
      id: 'executive',
      name: 'Yönetici Dashboard',
      description: 'Üst düzey özet ve tahminler',
      icon: <PieChartOutlined style={{ fontSize: '48px', color: '#722ed1' }} />,
      widgets: [
        { key: 'revenue-forecast', settings: { size: 'full' } },
        { key: 'competitor-analysis', settings: { size: 'large' } }
      ],
      tags: ['Özet', 'Tahmin', 'Strateji']
    },
    {
      id: 'operations',
      name: 'Operasyon Dashboard',
      description: 'Günlük operasyon ve kampanya takibi',
      icon: <DashboardOutlined style={{ fontSize: '48px', color: '#fa8c16' }} />,
      widgets: [
        { key: 'campaign-tracker', settings: { size: 'full' } },
        { key: 'revenue-forecast', settings: { size: 'medium' } },
        { key: 'social-metrics', settings: { size: 'medium' } }
      ],
      tags: ['Operasyon', 'Günlük', 'Takip']
    },
    {
      id: 'quick-start',
      name: 'Hızlı Başlangıç',
      description: 'En popüler widget\'lar ile başla',
      icon: <ThunderboltOutlined style={{ fontSize: '48px', color: '#faad14' }} />,
      widgets: [
        { key: 'revenue-forecast', settings: { size: 'medium' } },
        { key: 'campaign-tracker', settings: { size: 'medium' } },
        { key: 'social-metrics', settings: { size: 'medium' } },
        { key: 'competitor-analysis', settings: { size: 'medium' } }
      ],
      tags: ['Başlangıç', 'Popüler', 'Dengeli']
    },
    {
      id: 'blank',
      name: 'Boş Dashboard',
      description: 'Sıfırdan kendin oluştur',
      icon: <TeamOutlined style={{ fontSize: '48px', color: '#8c8c8c' }} />,
      widgets: [],
      tags: ['Boş', 'Özel']
    }
  ];

  const handleSelectTemplate = (template) => {
    onSelectTemplate(template);
    onClose();
  };

  return (
    <Modal
      title="Dashboard Template Seç"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <div style={{ marginBottom: 16 }}>
        <Text type="secondary">
          Hazır template'lerden birini seçerek hızlıca başlayabilir veya boş dashboard ile kendi tasarımınızı oluşturabilirsiniz.
        </Text>
      </div>

      <Row gutter={[16, 16]}>
        {templates.map(template => (
          <Col xs={24} sm={12} lg={8} key={template.id}>
            <Card
              hoverable
              onClick={() => handleSelectTemplate(template)}
              style={{ height: '100%', cursor: 'pointer' }}
            >
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                {template.icon}
              </div>
              
              <Title level={4} style={{ textAlign: 'center', marginBottom: 8 }}>
                {template.name}
              </Title>
              
              <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 16 }}>
                {template.description}
              </Text>

              <div style={{ textAlign: 'center', marginBottom: 8 }}>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  {template.widgets.length} widget
                </Text>
              </div>

              <div style={{ textAlign: 'center' }}>
                <Space size={[4, 4]} wrap>
                  {template.tags.map(tag => (
                    <Tag key={tag} style={{ fontSize: '11px' }}>{tag}</Tag>
                  ))}
                </Space>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: 24, textAlign: 'center' }}>
        <Button type="link" onClick={onClose}>
          İptal
        </Button>
      </div>
    </Modal>
  );
};

export default DashboardTemplates;